import React, { useEffect, useRef, useState } from "react"
import Modal from "react-bootstrap/Modal"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import Table from "react-bootstrap/Table"
import Form from "react-bootstrap/Form"
import { getAllConsultants, getAppointmentsByQuery } from "core/services/api"
import { useSelector } from "react-redux"
import AppointmentCalendarUtils from "components/AppointmentCalendar/AppointmentCalenderUtils"
import "./PrintCalender.scss"
import Print from "components/Print/Print"
// import jsPDF from "jspdf"
// import html2canvas from "html2canvas"


function PrintCalender({ closePrintModal, selectedItem, selectedMode }: any) {
  const userDetail = useSelector((state: any) => state?.user?.userDetail);
  let currentRole = userDetail?.currentRole;
  console.log(currentRole, "current Role");
  const [data, setData] = useState<any>([]);
  const [show, setShow] = useState(true);
  const componentRef = useRef(null);
  const handleClose = () => {
    setShow(false)
    closePrintModal(false)
  }

  useEffect(() => {
    getAllConsultants(`/consultants?centerId=${userDetail?.currentCenter?.centerId}`)
      .then((res) => {
        setData(res)
      })
      .catch((err) => {
        console.log("err", err)
      })

  }, [])

  //Initial Values
  const initialData = {
    consultantName: "",
    consultantId: "",
    appointmentType: "OPD",
    periodType: "Day",
    startDate: "",
    endDate: ""
  }


  // const selectedItem = moment().format("YYYY-MM-DD");
  const [printData, setPrintData] = useState<any>(initialData)
  console.log(printData, "printData");
  const onInput = (evnt: any) => {
    if (evnt.target.name === "consultantName") {
      setPrintData({
        ...printData,
        consultantName: evnt.target.value,
        consultantId: evnt.target.id,
      })
    }
    if (evnt.target.name === "appointmentType") {
      setPrintData({
        ...printData,
        appointmentType: evnt.target.value,
        consultantName: "",
        consultantId: ""
      })
    }
    if (evnt.target.name === "period") {
      setPrintData({
        ...printData,
        periodType: evnt.target.id,
      })

      //console.log(obj, "object");

    }
  }
  const [resData, setResData] = useState<any>();

  useEffect(() => {
    let obj = AppointmentCalendarUtils.fetchStartAndEndDate(
      selectedItem,
      printData.periodType
    )

    let query = `startDate=${obj?.startDate}&endDate=${obj?.endDate}`

    if (printData.appointmentType) {
      query = query + `&appointmentType=${printData.appointmentType}`
    }

    if (printData.consultantId) {
      query = query + `&consultantId=${printData.consultantId}`
    }

    query = query + `&centerId=${userDetail?.currentCenter?.centerId}`

    getAppointmentsByQuery(query).then((data) => {

      setResData(data);
    }).catch((err: any) => {
      console.log(err);
    })
  }, [printData.periodType, printData.appointmentType, printData.consultantId]);

  const stausRename = (value: any) => {
    if (value === 'CANCELLED') {
      return 'CANCEL'
    } else {
      return value
    }
  }




  return (
    <div className="print-calender-wrapper">
      <Modal className="print-calender-wrapper" size="xl" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title
            className="print-Heading"
          >Printing</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col sm={3}>
              <div className="print-subHeading">Filter Options</div>
              <div
                style={{

                  height: "fit-content",
                  backgroundColor: "#EEEEEE",
                  padding: "10px",
                }}
              >
                <Form className="forms">
                  <div className="mb-3">
                    <Form.Check inline label="OPD"
                      value="OPD"
                      name="appointmentType"
                      type="radio"
                      defaultChecked={true}
                      onChange={onInput}
                    />
                    <Form.Check inline label="IPD"
                      value="IPD"
                      name="appointmentType" type="radio"
                      onChange={onInput}
                    />
                    <Form.Check inline label="HC"
                      value="HC"
                      name="appointmentType" type="radio"
                      onChange={onInput}
                    />
                  </div>
                  <div className="mb-3">
                    <Form.Check
                      inline
                      label="Day"
                      name="period"
                      type="radio"
                      id="Day"
                      defaultChecked={true}
                      value={printData.periodType}
                      onChange={onInput}
                    />
                    <Form.Check
                      inline
                      label="Week"
                      name="period"
                      type="radio"
                      id="Week"
                      value={printData.periodType}
                      onChange={onInput}
                    />
                    <Form.Check
                      inline
                      label="Month"
                      name="period"
                      type="radio"
                      id="Month"
                      value={printData.periodType}
                      onChange={onInput}
                    />
                  </div>
                  <div className="mb-3">
                    <div className="print-subHeading"> Consultant</div>
                    {data?.map((item: any) =>
                      <>
                        <Form.Check
                          label={item?.name}
                          name="consultantName"
                          defaultValue={item?.name}
                          type="radio"
                          onChange={onInput}
                          value={item?.name}
                          id={item?.id}
                          checked={item?.name === printData?.consultantName ? true : false}
                        />
                      </>
                    )}



                  </div>
                  {/* <Button type="submit">Submit</Button> */}
                </Form>
              </div>
            </Col>

            <Col>
              <div className="print-subHeading">Preview</div>
              <Table id="tablePreview" bordered hover ref={componentRef}

              >
                <thead style={{ backgroundColor: "#E1E3EF" }}>
                  <tr>
                    <th>SL.no</th>
                    <th>Patient ID</th>
                    <th>Name</th>
                    <th>Phone Number</th>
                    <th>Appointment Type</th>
                    <th>Appointment Status</th>
                    {currentRole == "NURSE" ? <><th>Bed Status</th></> : <></>}

                  </tr>
                </thead>
                <tbody>
                  {resData?.map((item: any, index: any) =>
                    <tr>
                      <td>{index + 1}</td>
                      <td>{item?.mocId}</td>
                      <td>{item?.patientName}</td>
                      <td>{item?.primaryPhoneNumber}</td>
                      <td>{item?.appointmentType}</td>
                      <td>{stausRename(item?.status)}</td>
                      {currentRole == "NURSE" ? <> <td>

                        <ul>
                          <li>{item?.allottedBed?.bedName}</li>
                          <li>{item?.allottedBed?.roomName}</li>
                        </ul>



                      </td></> : <></>}


                    </tr>
                  )}
                </tbody>
              </Table>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Print componentRef={componentRef} buttonTitle="Print" />
        </Modal.Footer>
      </Modal>
    </div>
  )
}

export default PrintCalender

